import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const LoginMutation = gql`
  mutation login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      token
      user {
        id
        email
        language
        privileges
        countries {
          id
          name
        }
      }
    }
  }
`;

type InputProps = {
  children?: any;
  onSuccess?: Function;
  onError?: Function;
};

type Response = {
  data: any;
  authToken: string;
  login: any;
};

class AuthQuery extends React.Component<ChildProps<InputProps, Response>, {}> {
  constructor(props: any) {
    super(props);
    this.login = this.login.bind(this);
  }

  render() {
    const { forceLogin }: any = this.props;
    return this.props.children({
      login: this.login,
      forceLogin,
      isUserAuthenticated: this.isUserAuthenticated
    });
  }

  private isUserAuthenticated() {
    if (localStorage.getItem('token') != undefined) {
      return true;
    }

    return false;
  }

  private login(mutationVariables: any) {
    const { loginMutation }: any = this.props;
    loginMutation(mutationVariables)
      .then((loginResult: any) => {

        if (loginResult.data.login.token !== undefined) {
          localStorage.setItem('token', loginResult.data.login.token);
          localStorage.setItem('user', JSON.stringify(loginResult.data.login.user));
          return this.props.onSuccess && this.props.onSuccess(loginResult);
        }

        return (
          this.props.onError &&
          this.props.onError({ message: 'You do not have permissions for visiting backoffice.' })
        );
      })
      .catch(this.props.onError);
  }
}

export default compose(graphql<InputProps, Response>(LoginMutation, { name: 'loginMutation' }))(AuthQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Auth/Auth.tsx